export function updateUserIdInDataLayer(userId) {
  window.dataLayer.push({
    user_id: userId,
  });
}

export function trackLogin(userId, method = "website_default") {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "login",
      method: method,
    },
    user_id: userId,
  });
}

export function trackCreateObituary(obituaryId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "create_obituary",
      obituary_id: obituaryId,
    },
  });
}

export function trackSaveObituary(obituaryId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "save_obituary",
      obituary_id: obituaryId,
    },
  });
}

export function trackUploadObituaryPhoto(obituaryId, primaryPhoto) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "upload_obituary_photo",
      obituary_id: obituaryId,
      primary_photo: primaryPhoto,
    },
  });
}

export function trackSignUp(userId, method = "website_default") {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "sign_up",
      method: method,
    },
    user_id: userId,
  });
}

export function trackViewItemList(
  item_list_id,
  item_list_name,
  productEntries
) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "view_item_list",
      item_list_id: item_list_id,
      item_list_name: item_list_name,
      items: productEntries.map((x) => mapProductEntryToItem(x)),
    },
  });
}

export function trackViewItem(productEntry) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "view_item",
      value: productEntry.priceUnitAmount,
      items: [mapProductEntryToItem(productEntry)],
    },
  });
}

export function trackAddToCart(productEntry, addedQuantity = 1) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "add_to_cart",
      value: productEntry.priceUnitAmount * addedQuantity,
      items: [mapProductEntryToItem(productEntry, addedQuantity)],
    },
  });
}

export function trackRemoveFromCart(productEntry, removedQuantity = 1) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "remove_from_cart",
      value: productEntry.priceUnitAmount * removedQuantity,
      items: [mapProductEntryToItem(productEntry, removedQuantity)],
    },
  });
}

export function trackViewCart(cartLines) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "view_cart",
      value: getTotalFromCartLines(cartLines),
      items: getItemsFromCartLines(cartLines),
    },
  });
}

export function trackAddShippingInfo(cartLines) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "add_shipping_info",
      value: getTotalFromCartLines(cartLines),
      items: getItemsFromCartLines(cartLines),
    },
  });
}

export function trackBeginCheckout(cartLines) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "begin_checkout",
      value: getTotalFromCartLines(cartLines),
      items: getItemsFromCartLines(cartLines),
    },
  });
}

export function trackPurchase(orderId, cartLines) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "purchase",
      transaction_id: orderId,
      value: getTotalFromCartLines(cartLines),
      items: getItemsFromCartLines(cartLines),
    },
  });
}

const getTotalFromCartLines = (lines) => {
  const totalValue = (lines || []).reduce(
    (total, line) => total + line.quantity * line.product.priceUnitAmount,
    0
  );
  return totalValue;
};

const getItemsFromCartLines = (lines) => {
  return (lines || []).map((x) => mapProductEntryToItem(x.product, x.quantity));
};

const mapProductEntryToItem = (entry, quantity) => {
  return {
    item_id: entry.id,
    item_name: `${entry.name}:${entry.shortDescription}`,
    item_category: entry.category,
    item_category2: entry.includesBasicSubscription
      ? "BasicSubscriptionIncluded"
      : "NoSubscriptionIncluded",
    item_category3: entry.requiresObituaryId
      ? "RequiresObituary"
      : "NoObituaryRequired",
    price: entry.priceUnitAmount,
    quantity: quantity,
  };
};

// const eventProps = {
//   eventName: "",
//   method: "",
//   currency: "USD",
//   transaction_id: "blah",
//   value: 0.0,
//   item_list_id: "",
//   item_list_name: "",
//   obituary_id: 1,
//   primary_photo: false,
//   items: [
//     {
//       item_id: "",
//       item_name: "",
//       item_list_id: "",
//       price: 0.0,
//       quantity: 0,
//     },
//   ],
// };

// when they open up the wizard from anywhere
export function trackCreateWizardOpened(source = "default") {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "create_tribue_wizard_opened",
      source: source,
    },
  });
}

// wizard is closed by clicking off or clicking x
export function trackWizardClosed() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_closed",
    },
  });
}

// if they open up the create a wizard and there are drafts available
export function trackWizardDraftExistsViewed() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_drafts_viewed",
    },
  });
}

// if they view registration from clicking on the create tribute button
export function trackWizardRegistrationViewed() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_registration_viewed",
    },
  });
}

// if they complete registration from clicking on the create tribute button
export function trackWizardRegistrationCompleted(userId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_registration_completed",
    },
    user_id: userId,
  });
}

// if they view login from clicking on the create tribute button
export function trackWizardLoginViewed() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_login_viewed",
    },
  });
}

// the stage they are on in the wizard
export function trackObituaryStage(stageName, obituaryId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: `tribute_wizard_stage_${stageName}_viewed`,
      obituary_id: obituaryId,
    },
  });
}

// if they click upgrade at the end of the wizard
export function trackClickedUpgradeNow() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_clicked_upgrade_now",
    },
  });
}

// if they click manage subscription in user tributes
export function trackViewedManageSubscription(obituaryId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "user_tribute_viewed_manage_subscription",
      obituary_id: obituaryId,
    },
  });
}

// if they try to change the subscription on a tribute
export function trackAttemptedSwitchSubscription(obituaryId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "user_tribute_attempted_switch_subscription",
      obituary_id: obituaryId,
    },
  });
}

// if they successfully change the subscription on a tribute
export function trackSwitchSubscriptionSuccess(
  obituaryId,
  previous_subscription,
  new_subscription
) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "user_tribute_switch_subscription_success",
      obituary_id: obituaryId,
      previous_subscription: previous_subscription,
      new_subscription: new_subscription,
    },
  });
}

// if they click the no thanks button at the end of the wizard
export function trackClickedNoThanks() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_clicked_no_thanks",
    },
  });
}

// if they make it to the final step of the wizard
export function trackFinalStepViewed(obituaryId) {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_final_step_viewed",
      obituary_id: obituaryId,
    },
  });
}

// if they click the shop now button at the end of the wizard
export function trackClickedShopNow() {
  window.dataLayer.push({
    event: "genericEvent",
    eventProps: {
      eventName: "tribute_wizard_clicked_shop_now",
    },
  });
}
